namespace $.$$ {

	export class $shm_ba_dashboard extends $.$shm_ba_dashboard {

		@ $mol_mem
		app_id() {
			$mol_wire_solid()
			return super.app_id()
		}

		@ $mol_mem_key
		value( key: string, next?: any ) {
			$mol_wire_solid()
			return next
		}

		dev_mode() {
			return this.$.$mol_state_arg.value( 'dev_mode' ) === 'true'
		}

		screen_ids() {
			return this.dev_mode()
				? [ 'summary', 'charts', 'converter' ]
				: [ 'summary' ]
		}

		screen_arg( id: string ) {
			return {
				section: id === 'summary' ? null : id,
			}
		}

		screen_title( id: string ) {
			return {
				summary: 'Сводный отчет',
				charts: 'График',
				converter: 'Конвертер',
			}[ id ] ?? id
		}

		screen_current( id: string ) {
			return this.screen() === id
		}

		reports() {
			const dashboard_id = this.dashboard_model()?.id() ?? ''
			return $shm_ba_report.list( dashboard_id )
		}

		report( id: string ) {
			return this.reports().find( report => report.id() === id ) ?? null
		}

		report_tab_rows() {
			return this.reports().map( report => this.Report_tab( report.id() ) )
		}

		report_arg( id: string ) {
			return {
				report: id === 'default' ? null : id,
				section: null,
			}
		}

		report_title( id: string ) {
			return this.report( id )?.title() ?? id
		}

		report_current( id: string ) {
			return this.report_id() === id
		}

		report_actions( id: string ) {
			if( id === 'default' ) return [] as readonly $mol_view[]
			return [ this.Report_settings( id ) ]
		}

		report_settings_content( id: string ) {
			if( this.report_delete_showed( id ) ) return [
				this.Report_delete_text( id ),
				this.Report_delete_yes( id ),
				this.Report_delete_no( id ),
			]

			return [
				this.Report_title_input( id ),
				this.Report_delete( id ),
			]
		}

		@ $mol_mem_key
		report_settings_showed( id: string, next?: boolean ) {
			if( next === true ) this.report_delete_showed( id, false )
			return next ?? false
		}

		@ $mol_mem_key
		report_settings_outside_listener( id: string ) {
			if( !this.report_settings_showed( id ) ) return null
			return new this.$.$shm_listener(
				'pointerdown',
				event => this.report_settings_outside( id, event ),
				this.$.$mol_dom_context.document,
				{ passive: true },
			)
		}

		report_settings_outside( id: string, event?: PointerEvent ) {
			const target = event?.target
			if( !( target instanceof this.$.$mol_dom_context.Node ) ) return event ?? null
			if( this.Report_settings( id ).dom_node().contains( target ) ) return event ?? null
			if( this.Report_settings( id ).Bubble().dom_node().contains( target ) ) return event ?? null
			this.report_settings_showed( id, false )
			return event ?? null
		}

		@ $mol_mem_key
		report_delete_showed( id: string, next?: boolean ) {
			return next ?? false
		}

		@ $mol_mem_key
		report_title_draft( id: string, next?: string ) {
			return next ?? this.report_title( id )
		}

		@ $mol_action
		report_title_commit( id: string, next?: Event ) {
			if( next === undefined ) return null

			const report = this.report( id )
			if( !report || id === 'default' ) return next

			const prev = this.report_title( id )
			const title = this.report_title_draft( id ).trim()
			if( !title ) {
				this.report_title_draft( id, prev )
				return next
			}

			if( title !== prev ) report.rename( title )
			this.report_title_draft( id, title )
			return next
		}

		@ $mol_action
		report_title_keydown( id: string, next?: KeyboardEvent ) {
			if( next?.key !== 'Escape' ) return next ?? null

			next.preventDefault()
			this.report_title_draft( id, this.report_title( id ) )
			this.Report_title_input( id ).focused( false )
			return next
		}

		@ $mol_action
		report_delete_ask( id: string, next?: Event ) {
			if( next === undefined ) return null
			this.report_delete_showed( id, true )
			return next
		}

		@ $mol_action
		report_delete_confirm( id: string, next?: Event ) {
			if( next === undefined ) return null

			const report = this.report( id )
			this.report_delete_showed( id, false )
			this.Report_settings( id ).showed( false )
			if( !report || id === 'default' ) return next

			report.delete_later()
			if( this.report_id() === id ) this.report_id( 'default' )
			return next
		}

		report_delete_cancel( id: string, next?: Event ) {
			if( next === undefined ) return null
			this.report_delete_showed( id, false )
			return next
		}

		report_current_model() {
			return this.reports().find( report => report.id() === this.report_id() ) ?? this.reports()[0] ?? null
		}

		report_current_title() {
			return this.report_current_model()?.title() ?? ''
		}

		dashboard_self() {
			return this
		}

		report_custom() {
			return this.report_id() !== 'default'
		}

		report_id( next?: string ) {
			if( next !== undefined ) {
				this.$.$mol_state_arg.value( 'report', next === 'default' ? null : next )
				return next
			}

			const id = this.$.$mol_state_arg.value( 'report' ) ?? 'default'
			return this.reports().some( report => report.id() === id ) ? id : 'default'
		}

		dashboard_pages() {
			this.ba_mcp_client_auto()
			return [
				this.Report_page(),
				this.Filters_page(),
				... this.process_monitor_pages(),
			].filter( Boolean ) as $mol_view[]
		}

		process_monitor_pages() {
			return this.dev_mode() && this.process_monitor_opened() ? [ this.Process_monitor() ] : []
		}

		process_monitor_opened( next?: boolean ) {
			return this.$.$mol_state_local.value< boolean >( 'hitalama_ba_process_monitor_opened', next ) ?? false
		}

		screen( next?: string ) {
			if( next !== undefined ) {
				this.$.$mol_state_arg.value( 'section', next === 'summary' ? null : next )
				return next
			}

			const screen = this.$.$mol_state_arg.value( 'section' ) ?? 'summary'
			return this.screen_ids().includes( screen ) ? screen : 'summary'
		}

		dashboard_model() {
			return super.dashboard_model() as $shm_ba_dashboard_model | null
		}

		dashboard_model_files() {
			return this.dashboard_model()?.files() ?? []
		}

		dashboard_title() {
			return this.dashboard_model()?.title() ?? 'BA'
		}

		@ $mol_mem
		filter_state_store() {
			const obj = new this.$.$shm_ba_filter_state_store()
			obj.app_id = ()=> this.app_id()
			obj.has_source = ()=> this.has_source()
			obj.period_all = ()=> this.period_all()
			return obj
		}

		file_uri( next?: string ) {
			if( next !== undefined ) return this.filter_state_store().file_uri( next )

			const uri = this.filter_state_store().file_uri()
			if( uri ) return uri
			if( this.local_file_key() ) return ''

			return this.dashboard_model_files()[0]?.uri ?? ''
		}

		local_file_key( next?: string ) {
			return this.filter_state_store().local_file_key( next )
		}

		file( next?: File | null ) {
			return this.File_picker().file( next )
		}

		period( next?: $shm_ba_data_period ) {
			return this.filter_state_store().period( next )
		}

		tags_filter( next?: $shm_ba_data_filter ) {
			return this.filter_state_store().tags_filter( next )
		}

		authors_filter( next?: $shm_ba_data_filter ) {
			return this.filter_state_store().authors_filter( next )
		}

		sources_filter( next?: $shm_ba_data_filter ) {
			return this.filter_state_store().sources_filter( next )
		}

		message_types_filter( next?: $shm_ba_data_filter ) {
			return this.filter_state_store().message_types_filter( next )
		}

		source_types_filter( next?: $shm_ba_data_filter ) {
			return this.filter_state_store().source_types_filter( next )
		}

		search_query( next?: string ) {
			return this.filter_state_store().search_query( next )
		}

		@ $mol_mem
		search_query_draft( next?: string ) {
			if( next === undefined ) return this.search_query()
			return next
		}

		search_mode( next?: string ) {
			return this.filter_state_store().search_mode( next )
		}

		search_case_sensitive( next?: boolean ) {
			return this.filter_state_store().search_case_sensitive( next )
		}

		chart_metric( next?: string ) {
			return this.filter_state_store().chart_metric( next )
		}

		chart_group( next?: string ) {
			if( next === undefined ) {
				const group = this.filter_state_store().chart_group()
				const options = this.chart_group_options()
				if( group === 'minute5' ) return group
				if( group in options ) return group
				return this.chart_group_default()
			}
			return this.filter_state_store().chart_group( next )
		}

		chart_group_default() {
			if( this.period_is_one_day() ) return 'hour'
			if( this.period_is_one_month() ) return 'day'
			if( this.period_is_one_quarter() ) return 'month'
			return 'day'
		}

		period_years() {
			const period = this.period()
			return Number( period.to.slice( 0, 4 ) ) - Number( period.from.slice( 0, 4 ) ) + 1
		}

		chart_group_options() {
			const current = this.filter_state_store().chart_group()
			const selected = current === 'minute5' ? { minute5: 'По 5 минут' } : {}
			if( this.period_is_one_day() ) return {
				... selected,
				hour: 'По часам',
			}
			if( this.period_is_one_month() ) return {
				... selected,
				hour: 'По часам',
				day: 'По дням',
				week: 'По неделям',
			}
			if( this.period_is_one_quarter() ) return {
				... selected,
				hour: 'По часам',
				day: 'По дням',
				week: 'По неделям',
				month: 'По месяцам',
			}
			return {
				... selected,
				hour: 'По часам',
				day: 'По дням',
				week: 'По неделям',
				month: 'По месяцам',
				quarter: 'По кварталам',
				... this.period_years() > 1 ? { halfyear: 'По полугодиям' } : {},
				... this.period_years() > 1 ? { year: 'По годам' } : {},
			}
		}

		posts_sort( next?: string ) {
			return this.filter_state_store().posts_sort( next )
		}

		posts_sort_order( next?: string ) {
			return this.filter_state_store().posts_sort_order( next )
		}

		@ $mol_mem
		data() {
			const obj = new this.$.$shm_ba_data()
			obj.app_id = ()=> this.app_id()
			obj.file = ()=> this.file()
			obj.file_uri = ()=> this.file_uri()
			obj.file_token = ()=> this.$.$shm_ba_pb.file_token()
			obj.period = ()=> this.period()
			obj.tags_filter = ()=> this.tags_filter() as $shm_ba_data_filter
			obj.authors_filter = ()=> this.authors_filter() as $shm_ba_data_filter
			obj.sources_filter = ()=> this.sources_filter() as $shm_ba_data_filter
			obj.message_types_filter = ()=> this.message_types_filter() as $shm_ba_data_filter
			obj.source_types_filter = ()=> this.source_types_filter() as $shm_ba_data_filter
			obj.search_query = ()=> this.search_query()
			obj.search_mode = ()=> this.search_mode() as $shm_ba_data_search_mode
			obj.search_case_sensitive = ()=> this.search_case_sensitive()
			obj.chart_metric = ()=> this.chart_metric()
			obj.summary_indicators = ()=> this.summary_indicators()
			obj.chart_group = ()=> this.chart_group() as $shm_ba_chart_group
			obj.posts_sort = ()=> this.posts_sort()
			obj.posts_sort_order = ()=> this.posts_sort_order()
			obj.visible_tags = ()=> this.dashboard_model()?.visible_tags() ?? null
			obj.excluded_tags = ()=> this.dashboard_model()?.excluded_tags() ?? []
			return obj
		}

		has_source() {
			if( !this.file() && !this.file_uri() ) return false
			const ready = this.data().file_ready()
			if( $mol_promise_like( ready ) ) throw ready
			return true
		}

		report_rows() {
			this.summary_data_refresh()
			const has_source = this.$.$mol_error_fence< boolean | null >(
				()=> this.has_source(),
				error => $mol_fail( error ),
				promise => {
					this.summary_data_wait( promise )
					return null
				},
			)
			if( has_source === null ) return [ this.Summary_data() ]
			if( !has_source ) return [ this.Empty() ]
			if( this.report_custom() ) return [ this.Custom_report_screen() ]
			if( this.screen() === 'converter' ) return [ this.Converter_screen() ]
			return [
				this.screen() === 'charts'
					? this.Charts_screen()
					: this.Summary_screen(),
			]
		}

		query_summary() {
			return this.data().query_summary()
		}

		query_posts() {
			return this.data().query_posts()
		}

		query_posts_count() {
			return this.data().query_posts_count()
		}

		query_posts_page() {
			const posts = this.Posts()
			const limit = Number( posts.page_size() )
			const offset = posts.page() * limit
			return this.data().query_posts_page( `${ limit }:${ offset }` )
		}

		query_tables() {
			return this.data().query_tables()
		}

		query_sql( sql: string ) {
			return this.data().query_sql( sql )
		}

		@ $mol_mem
		summary_data_refresh( next?: number ) {
			return next ?? 0
		}

		@ $mol_action
		summary_data_wake() {
			this.summary_data_refresh( this.summary_data_refresh() + 1 )
			return null
		}

		@ $mol_mem_key
		summary_data_wait( promise: PromiseLike<unknown> ) {
			promise.then(
				()=> this.summary_data_wake(),
				()=> this.summary_data_wake(),
			)
			return null
		}

		summary_data_rows() {
			this.summary_data_refresh()
			const loading = this.$.$mol_error_fence(
				()=> {
					this.query_summary()
					this.chart_timeseries()
					return false
				},
				error => $mol_fail( error ),
				promise => {
					this.summary_data_wait( promise )
					return true
				},
			)

			return [
				this.Summary(),
				this.Timeseries_chart(),
				... loading ? [ this.Summary_loading() ] : [],
			] as readonly $mol_view[]
		}

		summary_loading_title() {
			return this.data().file_load_title()
		}

		tags() {
			return this.data().tags()
		}

		authors() {
			return this.data().authors()
		}

		sources() {
			return this.data().sources()
		}

		message_types() {
			return this.data().message_types()
		}

		source_types() {
			return this.data().source_types()
		}

		csv_file_name() {
			const period = this.period()
			const date = ( value: string )=> {
				const match = value.match( /^(\d{4})-(\d{2})-(\d{2})/ )
				return match ? `${ match[3] }.${ match[2] }.${ match[1] }` : value
			}
			const title = this.dashboard_title().replace( /[<>:"/\\|?*]+/g, ' ' ).trim() || 'Дашборд'
			return `${ title } ${ date( period.from ) }-${ date( period.to ) }.csv`
		}

		csv_blob() {
			return this.data().export_filtered_csv_blob( this.report_id() )
		}

		@ $mol_action
		csv_download( next?: Event ) {
			if( next === undefined ) return null
			next.preventDefault()
			$mol_wire_async( this ).csv_download_later().catch( error => $mol_fail_log( error ) )
			return next
		}

		csv_download_later() {
			const blob = this.csv_blob()
			const uri = URL.createObjectURL( blob )
			const link = this.$.$mol_dom_context.document.createElement( 'a' )
			link.href = uri
			link.download = this.csv_file_name()
			link.click()
			URL.revokeObjectURL( uri )
		}

		chart_timeseries() {
			return this.data().chart_timeseries()
		}

		wordstat_overlay_state_key( name: string ) {
			return `hitalama_ba_wordstat_overlay:${ this.app_id() }:${ this.report_id() }:${ name }`
		}

		wordstat_overlay_task_records() {
			const user = this.$.$shm_ba_pb.user_id()
			if( !user ) return [] as readonly $shm_ba_pb_file_record[]
			return this.$.$shm_ba_pb.records_page_realtime_live(
				`wordstat_tasks\nuser = "${ this.$.$shm_ba_pb.filter_text( user ) }"\nsort,title\n1\n200\nid,user,title,sort`,
				`wordstat_tasks/user:${ user }:ba-overlay`,
				record => String( record.user || '' ) === user,
			)
		}

		wordstat_overlay_task_titles() {
			return new Map( this.wordstat_overlay_task_records().map( record => [
				record.id,
				String( record.title || record.id ),
			]) )
		}

		wordstat_overlay_item_records() {
			const user = this.$.$shm_ba_pb.user_id()
			if( !user ) return [] as readonly $shm_ba_pb_file_record[]
			const tasks = new Set( this.wordstat_overlay_task_records().map( record => record.id ) )
			return this.$.$shm_ba_pb.records_page_realtime_live(
				`wordstat_task_items\ntask.user = "${ this.$.$shm_ba_pb.filter_text( user ) }" && status = "done"\nsort\n1\n1000\nid,task,query,region,period,device,status,date_from,date_to,row_count,sort`,
				`wordstat_task_items/user:${ user }:ba-overlay`,
				record => tasks.has( String( record.task || '' ) ),
				record => tasks.has( String( record.task || '' ) ) && String( record.status || '' ) === 'done',
			)
		}

		wordstat_overlay_series_id( record: $shm_ba_pb_file_record ) {
			return encodeURIComponent( JSON.stringify([
				String( record.task || '' ),
				String( record.query || '' ),
				String( record.region || '' ),
				String( record.device || '' ),
			]) )
		}

		@ $mol_mem
		wordstat_overlay_region_labels() {
			const labels = new Map< string, string >()
			const visit = ( nodes: readonly $shm_wordstat_region_info[] )=> {
				for( const node of nodes ) {
					labels.set( node.id, node.label )
					if( node.children?.length ) visit( node.children )
				}
			}
			visit( this.$.$shm_wordstat_region_tree() )
			return labels
		}

		wordstat_overlay_region_title( id: string ) {
			if( !id || id === 'Все' ) return 'Весь мир'
			return this.wordstat_overlay_region_labels().get( id ) ?? id
		}

		wordstat_overlay_device_title( id: string ) {
			return ({
				DEVICE_ALL: 'Все устройства',
				DEVICE_DESKTOP: 'ПК',
				DEVICE_MOBILE: 'Телефоны',
				DEVICE_TABLET: 'Планшеты',
			} as Record< string, string >)[ id ] ?? id
		}

		wordstat_overlay_series_options() {
			const task_titles = this.wordstat_overlay_task_titles()
			const available = new Set( this.wordstat_overlay_item_records().map( record => String( record.task || '' ) ) )
			const options: [ string, string ][] = [[ '', 'Отключить' ]]
			for( const [ id, title ] of task_titles ) if( available.has( id ) ) options.push([ id, title ])
			return Object.fromEntries([
				options[0],
				... options.slice( 1 ).toSorted( ( left, right )=> left[1].localeCompare( right[1], 'ru' ) ),
			])
		}

		wordstat_overlay_series( next?: string ) {
			const key = this.wordstat_overlay_state_key( 'series' )
			if( next !== undefined ) return this.$.$mol_state_local.value( key, next ) ?? next
			const value = this.$.$mol_state_local.value< string >( key ) || ''
			return value in this.wordstat_overlay_series_options() ? value : ''
		}

		wordstat_overlay_item() {
			const records = this.wordstat_overlay_selected_series_records().values().next().value
			return records ? this.wordstat_overlay_item_for( records ) : null
		}

		wordstat_overlay_selected_series_records() {
			const task = this.wordstat_overlay_series()
			const records = new Map< string, $shm_ba_pb_file_record[] >()
			for( const record of this.wordstat_overlay_item_records() ) {
				if( String( record.task || '' ) !== task ) continue
				const id = this.wordstat_overlay_series_id( record )
				const group = records.get( id ) ?? []
				group.push( record )
				records.set( id, group )
			}
			return records
		}

		wordstat_overlay_item_for( records: readonly $shm_ba_pb_file_record[] ) {
			const preferred = ({
				day: [ 'PERIOD_DAILY' ],
				week: [ 'PERIOD_WEEKLY', 'PERIOD_DAILY' ],
				month: [ 'PERIOD_MONTHLY', 'PERIOD_WEEKLY', 'PERIOD_DAILY' ],
				quarter: [ 'PERIOD_MONTHLY', 'PERIOD_WEEKLY', 'PERIOD_DAILY' ],
				halfyear: [ 'PERIOD_MONTHLY', 'PERIOD_WEEKLY', 'PERIOD_DAILY' ],
				year: [ 'PERIOD_MONTHLY', 'PERIOD_WEEKLY', 'PERIOD_DAILY' ],
			} as Record< string, readonly string[] >)[ this.chart_group() ] ?? []
			const priorities = [ ... new Set([ ... preferred, 'PERIOD_MONTHLY', 'PERIOD_WEEKLY', 'PERIOD_DAILY' ]) ]
			const range = this.period()
			for( const period of priorities ) {
				const record = records.find( item => {
					if( String( item.period || '' ) !== period ) return false
					const from = String( item.date_from || '' ).slice( 0, 10 )
					const to = String( item.date_to || '' ).slice( 0, 10 )
					return ( !from || from <= range.to.slice( 0, 10 ) ) && ( !to || to >= range.from.slice( 0, 10 ) )
				} )
				if( record ) return record
			}
			return null
		}

		wordstat_overlay_task_row_records() {
			const task = this.wordstat_overlay_series()
			if( !task ) return [] as readonly $shm_ba_pb_file_record[]
			return this.$.$shm_ba_pb.records_page_realtime_live(
				`wordstat_task_items\ntask = "${ this.$.$shm_ba_pb.filter_text( task ) }" && status = "done"\nsort\n1\n1000\nid,task,status,rows,updated`,
				`wordstat_task_items/task:${ task }:ba-overlay-rows`,
				record => String( record.task || '' ) === task,
				record => String( record.task || '' ) === task && String( record.status || '' ) === 'done',
			)
		}

		wordstat_overlay_rows_for( item: $shm_ba_pb_file_record, source: readonly $shm_wordstat_row[] ) {
			const rows = this.chart_timeseries() as readonly ( readonly [ string, number, string, string? ] )[]
			if( String( item.period || '' ) === 'PERIOD_MONTHLY' && [ 'day', 'week' ].includes( this.chart_group() ) ) {
				const values = new Map< string, number >()
				for( const point of source ) {
					const month = String( point.date || '' ).slice( 0, 7 )
					values.set( month, ( values.get( month ) ?? 0 ) + ( Number( point.count ) || 0 ) )
				}
				const shown = new Set< string >()
				return rows.map( row => {
					const month = this.chart_period_by_bucket( row[3] || row[2] ).from.slice( 0, 7 )
					if( shown.has( month ) ) return null
					shown.add( month )
					return values.get( month ) ?? null
				})
			}
			return rows.map( row => {
				const bucket = this.chart_period_by_bucket( row[3] || row[2] )
				let value = 0
				let found = false
				for( const point of source ) {
					const date = String( point.date || '' ).slice( 0, 10 )
					if( date < bucket.from.slice( 0, 10 ) || date > bucket.to.slice( 0, 10 ) ) continue
					value += Number( point.count ) || 0
					found = true
				}
				return found ? value : null
			})
		}

		wordstat_overlay_chart_series() {
			const row_records = new Map( this.wordstat_overlay_task_row_records().map( record => [ record.id, record ]) )
			const result: { title: string; rows: readonly ( number | null )[] }[] = []
			for( const records of this.wordstat_overlay_selected_series_records().values() ) {
				const item = this.wordstat_overlay_item_for( records )
				if( !item ) continue
				const source = row_records.get( item.id )?.rows as readonly $shm_wordstat_row[] | undefined
				if( !Array.isArray( source ) ) continue
				const rows = this.wordstat_overlay_rows_for( item, source )
				if( !rows.some( value => value !== null ) ) continue
				result.push({
					title: [
						String( item.query || '' ),
						this.wordstat_overlay_region_title( String( item.region || '' ) ),
						this.wordstat_overlay_device_title( String( item.device || '' ) ),
					].filter( Boolean ).join( ' · ' ),
					rows,
				})
			}
			return result
		}

		wordstat_overlay_rows() {
			return this.wordstat_overlay_chart_series()[0]?.rows ?? []
		}

		wordstat_overlay_selected_title() {
			return this.wordstat_overlay_task_titles().get( this.wordstat_overlay_series() ) || 'Wordstat'
		}

		wordstat_overlay_active() {
			return Boolean( this.wordstat_overlay_series() )
		}

		chart_period_pick( next?: string ) {
			if( next === undefined ) return null
			const group = this.chart_group()
			this.period( this.chart_period_by_bucket( next ) )
			if( group === 'week' ) this.chart_group( 'day' )
			if( group === 'hour' ) this.chart_group( 'minute5' )
			return next
		}

		chart_period_range_pick( next?: readonly string[] ) {
			if( next === undefined ) return null
			if( next.length < 2 ) return next

			const from = this.chart_period_by_bucket( next[0] )
			const to = this.chart_period_by_bucket( next[1] )
			this.period({
				from: from.from,
				to: to.to,
			})
			return next
		}

		chart_period_by_bucket( date: string ) {
			const group = this.chart_group()
			const day = this.date_day( date )
			if( group === 'hour' ) return this.chart_hour_period( date )
			if( group === 'minute5' ) return this.chart_minute5_period( date )
			if( group === 'month' ) return {
				from: day,
				to: this.date_shift_text( day, month => new Date( month.getFullYear(), month.getMonth() + 1, 0 ) ),
			}
			if( group === 'week' ) return {
				from: day,
				to: this.date_shift_text( day, week => new Date( week.getFullYear(), week.getMonth(), week.getDate() + 6 ) ),
			}
			if( group === 'quarter' ) return {
				from: day,
				to: this.date_shift_text( day, quarter => new Date( quarter.getFullYear(), quarter.getMonth() + 3, 0 ) ),
			}
			if( group === 'halfyear' ) return {
				from: day,
				to: this.date_shift_text( day, halfyear => new Date( halfyear.getFullYear(), halfyear.getMonth() + 6, 0 ) ),
			}
			if( group === 'year' ) return {
				from: day,
				to: this.date_shift_text( day, year => new Date( year.getFullYear(), year.getMonth() + 12, 0 ) ),
			}
			return { from: day, to: day }
		}

		date_shift_text( date: string, shift: ( date: Date )=> Date ) {
			const [ year, month, day ] = this.date_day( date ).split( '-' ).map( Number )
			const next = shift( new Date( year, month - 1, day ) )
			return [
				next.getFullYear(),
				String( next.getMonth() + 1 ).padStart( 2, '0' ),
				String( next.getDate() ).padStart( 2, '0' ),
			].join( '-' )
		}

		date_day( date: string ) {
			return date.slice( 0, 10 )
		}

		date_time_parts( date: string ) {
			const match = date.match( /^(\d{4}-\d{2}-\d{2})[ T](\d{2}):(\d{2})/ )
			if( !match ) return null
			return {
				day: match[1],
				hour: Number( match[2] ),
				minute: Number( match[3] ),
			}
		}

		date_time_text( day: string, hour: number, minute: number ) {
			return `${ day } ${ String( hour ).padStart( 2, '0' ) }:${ String( minute ).padStart( 2, '0' ) }`
		}

		chart_minute5_period( date: string ) {
			const parts = this.date_time_parts( date )
			if( !parts ) return { from: this.date_day( date ), to: this.date_day( date ) }
			const start_minute = Math.floor( parts.minute / 5 ) * 5
			return {
				from: this.date_time_text( parts.day, parts.hour, start_minute ),
				to: this.date_time_text( parts.day, parts.hour, start_minute + 4 ),
			}
		}

		chart_hour_period( date: string ) {
			const parts = this.date_time_parts( date )
			if( !parts ) return { from: this.date_day( date ), to: this.date_day( date ) }
			return {
				from: this.date_time_text( parts.day, parts.hour, 0 ),
				to: this.date_time_text( parts.day, parts.hour, 59 ),
			}
		}

		period_is_one_day() {
			const period = this.period()
			return this.date_day( period.from ) === this.date_day( period.to )
		}

		period_month( date: string ) {
			const [ year, month ] = date.split( '-' ).map( Number )
			return { year, month }
		}

		period_quarter( date: string ) {
			const month = this.period_month( date )
			return {
				year: month.year,
				quarter: Math.floor( ( month.month - 1 ) / 3 ),
			}
		}

		period_is_one_month() {
			const period = this.period()
			const from = this.period_month( period.from )
			const to = this.period_month( period.to )
			return from.year === to.year && from.month === to.month
		}

		period_is_one_quarter() {
			const period = this.period()
			const from = this.period_quarter( period.from )
			const to = this.period_quarter( period.to )
			return from.year === to.year && from.quarter === to.quarter
		}

		tag_messages_pie() {
			return this.data().tag_messages_pie()
		}

		period_all() {
			if( this.has_source() ) return this.data().period_all()
			return {
				from: '0001-01-01',
				to: '2999-12-31',
			}
		}

		@ $mol_mem
		Ba_mcp_client() {
			const obj = new this.$.$shm_ba_mcp_client()
			obj.dashboard = ()=> this
			return obj
		}

		ba_mcp_client_auto() {
			if( !this.agent_enabled() ) return null
			return this.Ba_mcp_client().auto()
		}

	}

}
